import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { connect } from 'react-redux';
import { setCandleType, sethistLen, setHorizon } from '../actions/settings';

const frequencyList = ['D', 'W', 'M'];
const histLenList = ['1Y', '2Y', '5Y'];
const horizonList = ['1M', '2M', '3M'];

const ChartSettings = ({
	candleType,
	histLen,
	horizon,
	setCandleType,
	sethistLen,
	setHorizon,
}) => {
	return (
		<Box sx={{ p: 2, minWidth: 200 }}>
			<Typography variant="subtitle1" gutterBottom>Settings</Typography>
			<Box sx={{ mb: 2 }}>
				<Typography variant="body2">Candle Type</Typography>
				<Box sx={{ display: 'flex', gap: 1 }}>
					{frequencyList.map(type => (
						<Button
							key={type}
							variant={candleType === type ? 'contained' : 'outlined'}
							size="small"
							onClick={() => setCandleType(type)}
						>
							{type}
						</Button>
					))}
				</Box>
			</Box>
			<Box sx={{ mb: 2 }}>
				<Typography variant="body2">History Length</Typography>
				<Box sx={{ display: 'flex', gap: 1 }}>
					{histLenList.map(len => (
						<Button
							key={len}
							variant={histLen === len ? 'contained' : 'outlined'}
							size="small"
							onClick={() => sethistLen(len)}
						>
							{len}
						</Button>
					))}
				</Box>
			</Box>
			<Box>
				<Typography variant="body2">Horizon</Typography>
				<Box sx={{ display: 'flex', gap: 1 }}>
					{horizonList.map(hrz => (
						<Button
							key={hrz}
							variant={horizon === hrz ? 'contained' : 'outlined'}
							size="small"
							onClick={() => setHorizon(hrz)}
						>
							{hrz}
						</Button>
					))}
				</Box>
			</Box>
		</Box>
	);
};

const mapStateToProps = state => ({
	candleType: state.settings.candleType,
	histLen: state.settings.histLen,
	horizon: state.settings.horizon,
});

const mapDispatchToProps = {
	setCandleType,
	sethistLen,
	setHorizon,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChartSettings);
